export enum ObservationConceptTypeEnum {
  Temperature = 1,
  HeartRate = 2,
  RespirationsPerMinute = 3,
  SystolicBloodPressure = 4,
  DiastolicBloodPressure = 5,
  O2SaturationAtRest = 6,
  O2SaturationWithExertion = 7,
  Pain = 8,
  Weight = 9,
  BloodBlucoseFasting = 10,
  BloodGlucoseRandom = 11,
  WeightGain = 12,
  WeightLoss = 13
}

export const ObservationConceptTypeOptions = [
{ id: 1, label: 'Temperature' },
{ id: 2, label: 'Heart Rate BPM' },
{ id: 3, label: 'Respirations Per Minute' },
{ id: 4, label: 'Systolic Blood Pressure' },
{ id: 5, label: 'Diastolic Blood Pressure' },
{ id: 6, label: 'O2 Saturation At Rest' },
{ id: 7, label: 'O2 Saturation With Exertion' },
{ id: 8, label: 'Pain' },
{ id: 9, label: 'Weight (total lbs)' },
{ id: 10, label: 'Blood Glucose Fasting' },
{ id: 11, label: 'Blood Glucose Random' },
{ id: 12, label: 'Weight (gain of lbs)' },
{ id: 13, label: 'Weight (loss of lbs)' }
];
